<template>
  <nav
    class="h-fit rounded-3xl overflow-hidden flex md:flex-col border-2 border-white bg-white"
  >
    <RouterLink
      v-for="item in items"
      :key="item.name"
      :to="{ name: item.name, params: { token } }"
      class="group flex-1 md:flex-none"
    >
      <div
        class="px-3 md:px-5 py-2.5 flex gap-x-3 items-center justify-center md:justify-start hover:bg-gray-100 transition-300 w-full"
        :class="route.name === item.name ? 'bg-gray-100' : ''"
      >
        <div
          class="p-2 bg-gray-250 w-fit h-fit flex items-center rounded-2lg border border-gray-250"
          :class="
            route.name === item.name ? 'bg-yellow-400 border-yellow-300' : ''
          "
        >
          <i
            :class="[
              item.icon,
              'text-gray-500 text-xl/5 transition-300',
              route.name === item.name ? '!text-white' : '',
            ]"
          />
        </div>
        <p class="text-sm text-dark font-semibold">{{ $t(item.label) }}</p>
      </div>
    </RouterLink>
  </nav>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const token = computed(() => String(route.params.token || ""));

// Only what a person who scanned a contract has any use for.
const items = [
  { name: "PublicPersonalInfo", label: "personal_info", icon: "icon-user" },
  { name: "PublicContacts", label: "contact", icon: "icon-ring-phone" },
];
</script>
